import DATE from '../../../DATE.js';
import DIV, { div } from '../../DOM/div/DIV.js';
import EL from '../../EL/EL.js';
import MAIN from '../../DOM/main/MAIN.js';
import { icon } from '../../SVG/icon/ICON.js';
import Activate from '../../../event/Activate.js';
import Collapse from '../../../event/Collapse.js';
import Deactivate from '../../../event/Deactivate.js';
import Expand from '../../../event/Expand.js';
import Swipeable from '../../../interface/Swipeable.js';
import Toggle from '../../../event/Toggle.js';
// import Translate from '../../../event/Translate.js';
import Translatable from '../../../interface/Translatable.js';
import FLEXHORIZONTAL from '../../COMPONENT/flex/FLEXHORIZONTAL.js';
import USER from '../../COMPONENT/user/USER.js';
import AuthenticationError from '../../../error/AuthenticationError.js';
import CONFIRM from '../../COMPONENT/dialog/confirm/CONFIRM.js';
import FOOTER from '../../DOM/footer/FOOTER.js';
import FORM from '../../DOM/form/FORM.js';
import FQDN from '../../../FQDN.js';
import HEADER from '../../DOM/header/HEADER.js';
import LOGOUT, { logoutDialog } from '../../APP/page/dialog/logout/LOGOUT.js';
import P from '../../DOM/p/P.js';
import PANE from '../../APP/page/pane/PANE.js';
import SIDEBAR, { sidebar } from '../../COMPONENT/sidebar/SIDEBAR.js';
import SITEFOOTER, { sitefooter } from '../../COMPONENT/sitefooter/SITEFOOTER.js';
import SITEHEADER, { siteheader } from '../../COMPONENT/siteheader/SITEHEADER.js';
import LOADER, { loader } from '../../COMPONENT/loader/LOADER.js';
import { consoleEl } from '../../COMPONENT/console/CONSOLE.js';
import { progressbar } from '../../COMPONENT/loader/PROGRESSBAR.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { SVGS } from '../../SVG/SVGS.js';
import { navheader } from '../../DOM/nav/navbar/navheader/NAVHEADER.js';
import { span } from '../../DOM/span/SPAN.js';
import { LANGUAGECODE } from '../../../event/Translate.js';
import { HTTPMETHOD } from '../../../enums/HTTPMETHOD.js';
// Model Structure
export const pageAttr = makeAttrStruct([
    ['id'],
    ['class']
]);
export const pageData = makeDataStruct([
    ['config'],
    ['authentication', 0],
    ['loader', loader('pageLoader', progressbar('Loading...'), consoleEl())]
]);
export const pageModel = makeStruct([
    ['attributes', pageAttr],
    ['data', pageData]
]);
// Simplified Model
export function page(id, config) {
    return {
        attributes: pageAttr(id),
        data: pageData(config, 0, loader('pageLoader', progressbar('Loading...'), consoleEl())),
    };
}
/** APP UI (PAGE) - SPWA implementation of the APP UI */
export default class PAGE extends MAIN {
    top;
    body;
    bottom;
    siteheader;
    horizontal;
    sidebarLeft;
    sidebarRight;
    sitefooter;
    loader;
    loginDisabled;
    constructor(node, model) {
        super(node, model);
        this.addClass('flex-vertical page');
        this.implement(new Translatable(this));
        this.authentication = 0;
        this.paneModels = model.data.config.page.panes;
        document.title = model.data.config.app.name + '_' + model.data.config.app.version;
        if (model.data.config.app.console.debug) {
            let url = new FQDN();
            document.title += ' (' + url.getSubdomain() + ')';
        }
        this.loginDisabled = model.data.config.page.loginDisabled || false;
        this.watchMousePosition();
        // console.log('PAGE top model:', div('flex-top top'));
        this.top = this.addChild(new DIV(this, div('flex-top top')));
        this.siteheader = this.addChild(new SITEHEADER(this.top, siteheader(navheader('siteHeader', undefined, span(model.data.config.app.label), icon(SVGS[model.data.config.app.icon])))));
        // this.btn_sidebarLeft = this.siteheader.header.navLeft.addSwitch(button('', 'toggle-left', icon(SVGS.ARROW_LEFT), 'Toggle the left sidebar (ctrl-left-arrow)', 'noLabel'));
        // this.btn_user = this.siteheader.header.navRight.addSwitch(button('', 'toggle-user', icon(new BADGE_CIRCLE().createSVGElementModel('XX')), 'Toggle the User Menu (ctrl-user)', 'noLabel'));
        // this.btn_sidebarRight = this.siteheader.header.navRight.addSwitch(button('', 'toggle-right', icon(SVGS.ARROW_RIGHT), 'Toggle the Right Sidebar (ctrl-right-arrow)', 'noLabel'));
        /** PAGE body contains Nav Elements and Content (Reports, Charts etc) */
        this.body = this.addChild(new DIV(this, div('flex-middle body')));
        this.horizontal = this.addChild(new FLEXHORIZONTAL(this.body, div()));
        /** A Sidebar contains nested lists representing aggregate queries */
        this.sidebarLeft = this.addChild(new SIDEBAR(this.horizontal.left, sidebar('left site-sidebar-left')));
        this.sidebarLeft.tabGroup.addClass('left');
        /** The right aligned Sidebar should contain context sensitive links based on the active Perspective/View/Component
            This should help in standardizing HELP contents
        */
        this.sidebarRight = this.addChild(new SIDEBAR(this.horizontal.right, sidebar('right site-sidebar-right')));
        this.sidebarRight.tabGroup.addClass('right');
        /** Loader and Logs */
        this.bottom = this.addChild(new DIV(this, div('flex-bottom bottom')));
        this.sitefooter = this.addChild(new SITEFOOTER(this.bottom, sitefooter()));
        this.loader = this.addChild(new LOADER(this, model.data.loader));
        this.on('translate', () => this.translate());
    }
    /** Retrieve the application config
        @return {config} The application configuration object
    */
    getConfig() {
        return this.data.config;
    }
    getCurrentLanguageCode() {
        return this.getConfig().translation.language.code;
    }
    translate() {
        let languageCode = this.getConfig().translation.language.code;
        this.getConfig().translation.translatable.forEach((child) => {
            const textGroup = child.getData('textGroup');
            const textKey = child.getData('textKey');
            if (textGroup && textKey) {
                const translatedText = this.getStringByParam(languageCode, textGroup, 'key', textKey);
                if (translatedText) {
                    child.setInnerHTML(translatedText);
                }
            }
        });
    }
    /** Returns the language ID for a given language code from this.config.languages
        @param {string} code - The language code (e.g., 'ca-fr')
        @returns {string} The language ID, or 'ca-en' if not found
    */
    getLanguageIdByCode(code) {
        if (Array.isArray(this.getConfig().translation.languages)) {
            const lang = this.getConfig().translation.languages.find((l) => l.code === code);
            return lang?.id;
        }
        return 'ca-en';
    }
    /** Asynchronously retrieves language data from the API and updates the config.
        @returns void Promise that resolves when the language data is retrieved and config is updated.
    */
    asyncGetLanguage() {
        // Skip API call if languages already loaded, but still update the language ID
        if (this.getConfig().translation.languages && this.getConfig().translation.languages.length > 0) {
            console.log('Languages already exist, updating language ID for current code');
            const newLanguageId = this.getLanguageIdByCode(this.getConfig().translation.language.code);
            if (newLanguageId) {
                this.getConfig().translation.language.id = newLanguageId;
                console.log(`Updated language ID to '${newLanguageId}' for code '${this.getConfig().translation.language.code}'`);
            }
            else {
                console.error(`Language code '${this.getConfig().translation.language.code}' not found in languages list.`);
                return Promise.reject(new Error(`Language code '${this.getConfig().translation.language.code}' not found.`));
            }
            return Promise.resolve();
        }
        let url = `${this.getConfig().translation.apiEndpoint}/string/language/list`;
        return new Promise((resolve, reject) => this.getJson(url, (response) => {
            // Handle both paginated response and plain array (backward compatible)
            const lang = Array.isArray(response) ? response : response.data;
            this.getConfig().translation.languages = lang;
            this.getConfig().translation.language.id = this.getLanguageIdByCode(this.getConfig().translation.language.code);
            if (!this.getConfig().translation.language.id) {
                console.error(`Language code '${this.getConfig().translation.language.code}' not found.`);
                reject(new Error(`Language code '${this.getConfig().translation.language.code}' not found.`));
            }
            this.logInfo(`Loaded ${lang.length} languages, set current to '${this.getConfig().translation.language.code}' (ID: ${this.getConfig().translation.language.id})`);
            resolve();
        }));
    }
    /** Asynchronously retrieves the top text group from the API and updates the config.
        @param groupKey The key of the text group to retrieve.
        @returns void Promise that resolves when the top text group is retrieved and config is updated.
    */
    asyncGetTopGroup(groupKey) {
        // Skip if group already exists
        if (this.getConfig().translation.groups[groupKey]) {
            // this.logInfo(`Top group '${groupKey}' already exists`);
            return Promise.resolve();
        }
        let url = `${this.getConfig().translation.apiEndpoint}/string/textgroup/list?key=${groupKey}`;
        return new Promise((resolve, reject) => this.getJson(url, (response) => {
            // Handle both paginated response and plain array (backward compatible)
            const topgroup = Array.isArray(response) ? response : response.data;
            if (topgroup.length === 0) {
                this.logError(`Text group with key '${groupKey}' not found.`);
                reject(new Error(`Text group with key '${groupKey}' not found.`));
            }
            this.getConfig().translation.groups[groupKey] = topgroup[0];
            this.getConfig().translation.textgroups[groupKey] = topgroup[0];
            resolve();
        }));
    }
    /** Asynchronously retrieves all top text groups from the API and updates the config.
        @returns void Promise that resolves when all top text groups are retrieved and config is updated.
    */
    asyncGetAllTopGroups() {
        let promises = [];
        this.getConfig().translation.groupKey.forEach((groupKey) => {
            promises.push(this.asyncGetTopGroup(groupKey));
        });
        return Promise.all(promises).then(() => { });
    }
    /** Asynchronously retrieves child text groups from the API for a specific parent group and updates the config.
        @param parentGroupId The ID of the parent group.
        @returns void Promise that resolves when the child text groups are retrieved and config is updated.
    */
    asyncGetChildGroups(parentGroupId) {
        let url = `${this.getConfig().translation.apiEndpoint}/string/textgroup/list?parentId=${parentGroupId}`;
        return new Promise((resolve, reject) => this.getJson(url, (response) => {
            // Handle both paginated response and plain array (backward compatible)
            const tgrp = Array.isArray(response) ? response : response.data;
            tgrp.forEach((textgroup) => {
                // Only add if doesn't already exist
                if (!this.getConfig().translation.textgroups[textgroup.key]) {
                    this.getConfig().translation.textgroups[textgroup.key] = textgroup;
                }
                // else {
                // 	console.log(`Child group '${textgroup.key}' already exists`);
                // }
            });
            resolve();
        }));
    }
    /** Asynchronously retrieves all child text groups from the API for all parent groups and updates the config.
        @returns void Promise that resolves when all child text groups are retrieved and config is updated.
    */
    asyncGetAllChildGroups() {
        let promises = [];
        Object.keys(this.getConfig().translation.groups).forEach((groupKey) => {
            const group = this.getConfig().translation.groups[groupKey];
            if (group && group.id) {
                promises.push(this.asyncGetChildGroups(group.id));
            }
        });
        return Promise.all(promises).then(() => { });
    }
    /** Asynchronously retrieves text for a specific text group from the API and updates the config.
        @returns void Promise that resolves when the text for the group is retrieved and config is updated.
    */
    asyncGetTextForGroup(groupKey) {
        return new Promise((resolve, reject) => {
            let textgroup = this.getConfig().translation.textgroups[groupKey];
            if (!textgroup) {
                reject(new Error(`Text group with key '${groupKey}' not found in config.`));
                return;
            }
            // Skip if text already loaded for this group
            const langCode = this.getConfig().translation.language.code;
            if (this.getConfig().translation.text[langCode]?.[textgroup.key] &&
                Object.keys(this.getConfig().translation.text[langCode][textgroup.key]).length > 0) {
                // console.log(`Text for group '${textgroup.key}' (${langCode}) already exists`);
                resolve();
                return;
            }
            let url = `${this.getConfig().translation.apiEndpoint}/string/text/list?languageId=${this.getConfig().translation.language.id}&groupId=${textgroup.id}`;
            this.getJson(url, (response) => {
                // Handle both paginated response and plain array (backward compatible)
                const txt = Array.isArray(response) ? response : response.data;
                // Ensure the language code object exists and is unique
                if (!this.getConfig().translation.text[langCode]) {
                    this.getConfig().translation.text[langCode] = Object.create(null);
                }
                // Ensure the text group object is unique
                this.getConfig().translation.text[langCode][textgroup.key] = Object.create(null);
                txt.forEach((t) => {
                    this.getConfig().translation.text[langCode][textgroup.key][t.key] = t;
                });
                console.debug(`Loaded ${txt.length} text entries for group '${textgroup.key}' in language '${langCode}'`);
                resolve();
            });
        });
    }
    asyncValidateSession() {
        this.logInfo('Validating session token');
        let url = this.getConfig().auth.url.validate;
        return new Promise((resolve, reject) => {
            let isValid = false;
            this.getJson(url, (payload, status) => {
                this.logInfo('Validate Token', payload, status);
                if (payload.valid) {
                    ['userId', 'username', 'roles'].forEach((key) => {
                        if (payload[key]) {
                            window.sessionStorage.setItem(key, payload[key]);
                        }
                    });
                    isValid = true;
                }
                else {
                    ['roles', 'userId', 'username'].forEach((item) => window.sessionStorage.removeItem(item));
                    if (status === 401) {
                        this.logInfo('Token invalid: Unauthorized (401)');
                        if (typeof window.sessionStorage.getItem('refreshToken') === 'string') {
                            this.logInfo('Attempting token refresh with refresh token');
                            this.getJson(this.config.auth.url.refresh, (refreshPayload, refreshStatus) => {
                                if (typeof refreshPayload.token === 'string') {
                                    // Store token values in session
                                    Object.keys(payload).forEach((key) => window.sessionStorage.setItem(key, refreshPayload[key]));
                                    this.logInfo('Session refreshed. Reloading application.');
                                    history.pushState({}, document.title);
                                    location.reload();
                                    isValid = true;
                                }
                            }, HTTPMETHOD.POST, undefined, window.sessionStorage.getItem('refreshToken') || undefined, {
                                'refreshToken': window.sessionStorage.getItem('refreshToken')
                            });
                        }
                        else {
                            this.logInfo('Refresh Token unavailable.  User is anonymous');
                        }
                    }
                    else {
                        this.logInfo('Session invalid. Please log in again.');
                    }
                    // Token is invalid.  Clear session values
                    // this.clearUserSession();
                }
                resolve(isValid);
            }, HTTPMETHOD.GET, undefined, window.sessionStorage.getItem('token') || undefined);
        });
    }
    /** Asynchronously builds the configuration by retrieving language and text group data from the API.
        @returns void Promise that resolves when the configuration is fully built.
    */
    asyncBuildConfig() {
        this.getConfig().translation.language.code = window.sessionStorage.getItem('language') || LANGUAGECODE.CA_EN;
        return new Promise((resolve, reject) => {
            this.asyncGetLanguage().then(() => {
                this.asyncGetAllTopGroups().then(() => {
                    this.asyncGetAllChildGroups().then(() => {
                        let promises = [];
                        Object.keys(this.getConfig().translation.textgroups).forEach((textgroupKey) => promises.push(this.asyncGetTextForGroup(textgroupKey)));
                        Promise.all(promises).then(() => {
                            resolve();
                        }).catch((error) => console.error('Error retrieving text groups', reject(error)));
                    }).catch((error) => console.error('Error retrieving child group data:', reject(error)));
                }).catch((error) => console.error('Error retrieving top group data:', reject(error)));
            });
        });
    }
    /** Returns a list of unique parentIds from this.config.text['ca-en']['EthicalBreachType'].childGroups
        @returns {string[]} Array of unique parentIds
    */
    getUniqueParentIds(languageCode, key) {
        const items = this.getConfig().translation.text[languageCode][key];
        if (!Array.isArray(items))
            return [];
        const parentIds = items.map((group) => group.parentId).filter(Boolean);
        return Array.from(new Set(parentIds));
    }
    /** Retrieves MAIN
        @override
        @return {ThisType} The MAIN instance
    */
    getMain() {
        return this;
    }
    /** Retrieves a string value from config text based on a parameter name and value
        @param {string} languageCode - The language code (e.g., 'ca-en')
        @param {string} key - The text group key (e.g., 'EthicalBreachTypeSummary')
        @param {string} paramName - The parameter name to search by (e.g., 'parentId')
        @param {string} paramValue - The parameter value to match
        @returns {string} The corresponding string value, or an empty string if not found
    */
    getStringByParam(languageCode, key, paramName, paramValue) {
        const itemsObj = this.getConfig().translation.text[languageCode][key];
        if (!itemsObj || typeof itemsObj !== 'object') {
            console.warn(`No items found for language '${languageCode}' and key '${key}'`);
            return '';
        }
        const items = Object.values(itemsObj);
        const item = items.find((group) => group[paramName] === paramValue);
        return item ? item.value : '';
    }
    /** Returns whether login is disabled
        @return {boolean} True if login is disabled, false otherwise
    */
    getLoginDisabled() {
        return this.loginDisabled;
    }
    // addNavTab(target, text, title) {
    // 	let tab = this.sidebarRight.tabGroup.addTab(
    // 		MODELS.tab(
    // 			ModelAttr.tab('HEADER', title, 'no-btn-close no-btn-state'),
    // 			ModelData.tab(
    // 				MODELS.button(
    // 					ModelAttr.button('BUTTON', 'HEADER', title),
    // 					ModelData.button(new STRING(text).truncate(30))
    // 				)
    // 			)
    // 		)
    // 	);
    // 	tab.data.target = target;
    // 	tab.on('activate', () => target.scrollTo({
    // 		behavior: 'smooth',
    // 		block: 'center',
    // 		inline: 'start'
    // 	}));
    // }
    // /** keyPressUpDown(event)
    // 	Captures up/down/enter keypresses for simple navigation of an OptionList
    // 	@param event Key Press Event
    // */
    // keyPressUpDown(event: KeyboardEvent): void {
    // 	switch (event.keyCode) {
    // 		case 38: // up
    // 			console.log('up');
    // 			event.preventDefault();
    // 			event.stopPropagation();
    // 			this.search.datalist.activatePrev();
    // 			break;
    // 		case 40: // down
    // 			console.log('down');
    // 			event.preventDefault();
    // 			event.stopPropagation();
    // 			this.search.datalist.activateNext();
    // 			break;
    // 		case 13: // enter
    // 			console.log('enter pressed', this.search.datalist.getActivatedOption()); //.getAttribute('value')
    // 			event.preventDefault();
    // 			event.stopPropagation();
    // 			break;
    // 		default:
    // 			console.log(event.keyCode);
    // 	}
    // }
    //this.activeTab.on('activate', () => console.info('todo: n/a'));
    // this.btn_user.on('activate', () => {
    // 	if (this.getMain().loggedIn()) {
    // 		this.getMain().logout(this.btn_user, this.getMain().loader);
    // 	} else {
    // 		this.getMain().login(this.btn_user, this.getMain().loader);
    // 	}
    // });
    /** Toggle Dark Theme
    this.btn_theme = this.header.navRight.addSwitch(MODELS.button(
        ATTR.button('BUTTON', 'toggle-theme', 'Toggles Light/Dark Theme', 'noLabel'),
        DATA.button('Theme', ICONS.SUNGLASSES)
    )).on('activate', () => {
        document.body.classList.add('dark-theme');
        window.localStorage.setItem('dark-theme', 1);
    }).on('deactivate', () => {
        document.body.classList.remove('dark-theme');
        window.localStorage.setItem('dark-theme', 0);
    });
    if (window.localStorage.getItem('dark-theme') === '1') {
        this.btn_theme.do(new Activate());
    }
    */
    /*
    if(this.url.searchParams.get('dark-theme') === '1') {
        this.btn_theme.do(new Activate());
        //document.body.classList.add('dark-theme');
    }
    */
    /* Prevent page submission when search value is submitted */
    // this.search.forminput.input.el.addEventListener('keydown', (e) => {
    // 	if (e.which === 13) { // enter key
    // 		e.preventDefault();
    // 		console.log('debug: enter search');
    // 		//this.search.query();
    // 		this.search.forminput.input.el.value = '';
    // 		this.search.forminput.datalist.empty();
    // 		this.btn_search.do(new Deactivate());
    // 	}
    // });
    // Trigger Perspectives
    // this.btn_Perspectives.on('activate', () => {
    // 	// this.btn_search.do(new Deactivate());
    // 	// this.controls.do(new Activate());
    // 	window.localStorage.setItem('perspectives-active', '1');
    // 	console.log('perspectives-active: 0');
    // }).on('deactivate', () => {
    // 	// this.controls.do(new Deactivate());
    // 	window.localStorage.setItem('perspectives-active', '0');
    // });
    // if (window.localStorage.getItem('perspectives-active') === '1') {
    // 	this.btn_Perspectives.do(new Activate());
    // 	console.log('perspectives-active: 1');
    // }
    // Trigger Search
    // this.btn_search.on('activate', () => {
    // 	this.btn_Perspectives.do(new Deactivate());
    // 	// this.search.do(new Activate());
    // 	// this.search.forminput.input.el.focus();
    // 	console.log('Activate search');
    // 	window.localStorage.setItem('search-active', '1');
    // 	this.on('keydown', (event) => this.keyPressUpDown(event));
    // }).on('deactivate', () => {
    // 	// this.search.forminput.datalist.empty();
    // 	// this.search.do(new Deactivate());
    // 	console.log('Deactivate search');
    // 	window.localStorage.setItem('search-active', '0');
    // 	this.el.removeEventListener('keydown', (event) => this.keyPressUpDown(event));
    // });
    // if (window.localStorage.getItem('search-active') === '1') {
    // 	this.btn_search.do(new Activate());
    // }
    // // Trigger Sidebar (Left)
    // this.btn_sidebarLeft.on('activate', () => {
    // 	const actualWidth = window.innerWidth * window.devicePixelRatio;
    // 	console.log('width', window.innerWidth, window.devicePixelRatio, actualWidth, CONFIG.layout.mobile.maxWidth);
    // 	if (actualWidth > CONFIG.layout.mobile.maxWidth) {
    // 		window.localStorage.setItem('sidebarLeft-active', '1');
    // 		this.getMain().sidebarLeft.activate();
    // 	} else {
    // 		console.log('Unable to activate sidebar due to limited screen space');
    // 		this.btn_sidebarLeft.deactivate();
    // 	}
    // }).on('deactivate', () => {
    // 	window.localStorage.setItem('sidebarLeft-active', '0');
    // 	this.getMain().sidebarLeft.deactivate();
    // });
    // if (window.localStorage.getItem('sidebarLeft-active') === '1') {
    // 	console.log('verify sidebar:' + this.hasClass('embedded'));
    // 	if (this.hasClass('embedded')) {
    // 		this.btn_sidebarLeft.do(new Deactivate());
    // 	} else {
    // 		this.btn_sidebarLeft.do(new Activate());
    // 	}
    // }
    // // Trigger Sidebar (Right)
    // this.btn_sidebarRight.on('activate', () => {
    // 	const actualWidth = window.innerWidth * window.devicePixelRatio;
    // 	console.log('width', window.innerWidth, window.devicePixelRatio, actualWidth, CONFIG.layout.mobile.maxWidth);
    // 	if (actualWidth > CONFIG.layout.mobile.maxWidth) {
    // 		window.localStorage.setItem('sidebarRight-active', '1');
    // 		this.getMain().sidebarRight.activate();
    // 	} else {
    // 		console.log('Unable to activate sidebar due to limited screen space');
    // 		this.btn_sidebarRight.deactivate();
    // 	}
    // }).on('deactivate', () => {
    // 	window.localStorage.setItem('sidebarRight-active', '0');
    // 	this.getMain().sidebarRight.deactivate();
    // });
    // if (window.localStorage.getItem('sidebarRight-active') === '1') {
    // 	this.btn_sidebarRight.do(new Activate());
    // }
    /** Detects mouse position for desktop and caches its value every X ms
        @param {number} delay Millisecond delay between caches
    */
    watchMousePosition(delay = 50) {
        this.data.mouse = {
            x: 0,
            y: 0,
            w: document.body.clientWidth,
            h: document.body.clientHeight,
            xPct: 0,
            yPct: 0
        };
        document.onmousemove = (ev) => this.handleMouseMove(ev);
        document.body.onresize = () => this.handleResize();
        setInterval(() => this.cacheMouse(), delay); // setInterval repeats every X ms ~41 ms == 24fps
    }
    /** Updates the Mouse Position Cache
        param {Event} ev Resize Event
    */
    handleResize() {
        this.data.mouse.w = document.body.clientWidth;
        this.data.mouse.h = document.body.clientHeight;
    }
    /** Mouse Move Event Handler (Desktop Only) creates a cache of the mouse coordinates */
    handleMouseMove(event) {
        this.data.mouse.x = event.pageX;
        this.data.mouse.y = event.pageY;
    }
    /** Set the Mouse Position and relative positioning */
    cacheMouse() {
        this.data.mouse.xPct = Number((this.data.mouse.x / this.data.mouse.w).toFixed(2)) * 100;
        this.data.mouse.yPct = Number((this.data.mouse.y / this.data.mouse.h).toFixed(2)) * 100;
    }
    /** Acts as an undo or back function */
    navigateBack() {
        console.log('TODO: Back');
    }
    /** Acts as an redo or forward function */
    navigateForward() {
        console.log('TODO: Forward');
    }
    /** Swipe Up Event */
    swipeUp() {
        console.log('MAIN.swipeUp()');
    }
    /** Swipe Down Event */
    swipeDown() {
        console.log('MAIN.swipeDown()');
    }
    getBody() {
        return this.node;
    }
    /** Triggers a LOGIN dialog */
    login(caller, loader) {
        if (this.loggedIn() || this.loginDisabled) {
            console.log('Already logged in (' + this.loginDisabled + ')');
        }
        else {
            this.getMain().login(this, this.getMain().loader);
            // try {
            // 	new LOGIN(
            // 		this.getBody(),
            // 		loginDialog(
            // 			this.getConfig().auth.url.login,
            // 			caller,
            // 			loader,
            // 		)
            // 	).showModal(0);
            // } catch (e) {
            // 	console.warn('Unable to toggle login', e);
            // }
        }
    }
    /** Triggers a LOGOUT dialog */
    logout(caller, loader) {
        if (this.loggedIn()) {
            try {
                let confirm = new LOGOUT(this.getBody(), logoutDialog(this.getConfig().auth.url.logout, caller, loader));
                confirm.show();
            }
            catch (e) {
                console.warn('Unable to toggle login', e);
            }
        }
        else {
            this.login(caller, loader); //this.footer.btn_right, loader = this.loader
        }
    }
    /** Sets the application authentication to the given value (1|0)
        @param {number} auth Application Authentication
    */
    setAuthentication(auth) {
        this.authentication = auth;
    }
    /** Verifies if a valid session exists
        If a cached session exists, ensure that it is still valid
    */
    loggedIn() {
        // Check if token exists...
        let valType = typeof window.sessionStorage.getItem('sessionStart');
        let valid_session = 0;
        console.log('sessionStart type: ' + valType);
        if (valType === 'string') {
            // Check if token is expired (less than 12 hours old)
            let date_now = new DATE();
            let date_expires = new DATE(String(window.sessionStorage.getItem('sessionStartUTC'))).addHours(new DATE().getUTCOffsetHours()).addHours(12);
            valid_session = date_expires > date_now ? 1 : 0;
            //console.log('Date Check', date_now, date_expires, valid_session);
            if (valid_session) {
                console.log('Session is valid.');
            }
            else {
                console.log('Session has expired.  You must log in to continue');
                // Clear out expired values
                [
                    'sessionId', 'sessionStart', 'sessionStartUTC',
                    'sessionRefreshUTC', 'basicAuth', 'password'
                ].forEach((item) => window.sessionStorage.removeItem(item));
            }
        }
        else {
            console.log('Session data not available.');
        }
        this.setAuthentication(valid_session);
        return this.authentication;
    }
    /** Shows the MAIN Progress Bar with the given status
        @param {string} [text] Optional text to display in progress bar
    */
    showProgressBar(text = '...') {
        this.progressBar.text.setInnerHTML(text);
        this.progress.setAttribute('style', 'display:block;');
    }
    /** Hides the MAIN Progress Bar */
    hideProgressBar() {
        this.progress.setAttribute('style', 'display:none;');
        this.progressBar.text.setInnerHTML('');
    }
    getActivePerspective() {
        return this.activeTab.getLabel();
    }
}
export { Activate, AuthenticationError, Collapse, CONFIRM, Deactivate, EL, Expand, FOOTER, FORM, HEADER, MAIN, P, PANE, Swipeable, Toggle, USER };
